@if (!isAuthoring && loginInfo) {
  <div class='producer-change-agency-container' [ngClass]="{'flex-change' : !isAgencyOnlyMode }"
    >
    <div class="div-left" [ngClass]="{'include-slots' : !isAgencyOnlyMode }">
      <div [hidden]="isAgencyOnlyMode">
        <h3 class="sub-header">
          <slot name="text_two">Enter state and Agency Details</slot>
        </h3>
        <div class='sub-text'>
          <slot name="subText_two">
          </slot>
        </div>
      </div>
      <form [formGroup]="agencyForm">
        <!-- Agency Name-->
        <div class="agency-preferences-container">
          @if (showRegionFilter) {
            <mat-form-field appearance="outline">
              <mat-label>Region</mat-label>
              <mat-select formControlName="region" (selectionChange)="updateAgencyList()">
                @for (reg of availableRegions; track reg) {
                  <mat-option [value]="reg">{{reg}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          <mat-form-field appearance="outline" class="agency-field">
            <mat-label>Agency</mat-label>
            <mat-select formControlName="agency" (selectionChange)="agencyChange($event.value)" [compareWith]="trackAgencyComparison">
              @for (agency of agenciesForDisplay; track agency) {
                <mat-option [value]="agency">
                  {{ formatAgencyName(agency.agencyName) }} - {{agency.region}} - {{ agency.agencyId}}
                </mat-option>
              }
            </mat-select>
            @if (!enrollmentSubmitMode) {
              <mat-hint>{{ getPreferredAgencyHint() }}</mat-hint>
            }
          </mat-form-field>
          <!-- REMEMBER ME -->
          @if (updateRememberMeCheckboxVisibility()) {
            <div class='remember-checkbox'>
              <mat-checkbox formControlName="rememberSelection"></mat-checkbox>
              <div class='remember-checkbox-label'>
                Change your Preferred Agency to
                {{ formControls.agency.value.agencyName + ' - ' +
                formControls.agency.value.region }}
              </div>
            </div>
          }
          @if (!isAgencyOnlyMode || enrollmentSubmitMode) {
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>National Producer Number</mat-label>
              <input matInput type="text"
                formControlName="npnNumber"
                pattern="[a-zA-Z0-9]*"
                placeholder="{{npnPlaceholderText}}"
                maxlength='10' />
                @if (formControls.npnNumber.errors?.required) {
                  <mat-error>This field is required</mat-error>
                }
                @if (formControls.npnNumber.errors?.pattern) {
                  <mat-error>NPN must be numbers only</mat-error>
                }
              </mat-form-field>
            }
          </div>
          <div [hidden]="hideZipcodeBool && !enrollmentSubmitMode">
            @if (!enrollmentSubmitMode) {
              <div class='sub-text'>
                <slot name="subText_three">
                  Add client's zip code and county information to view products.
                </slot>
              </div>
            }
            <!-- ignoreCookieUpdates="true" -->
            <ptl-zip-code-and-county-select
              [disabled]="enrollmentSubmitMode"
              [preloadedValues]="stateValues"
              [ignoreCookieUpdates]="ignoreCookieUpdates"
              (zipAndCountyChanged)="zipCountyChanged($event)"
            ></ptl-zip-code-and-county-select>
            <div class="button-and-errors">
              <div class="errors">
                <!-- ERRORS -->
                @if (regionMismatch) {
                  <mat-error>
                    Selected agency region does not match the zipcode
                  </mat-error>
                }
              </div>
              <br/>
            </div>
            <div [hidden]="!isFieldAgent || enrollmentSubmitMode">
              <mat-checkbox formControlName="isOnCallWithFieldAgent">
                <slot name="subText_four">
                  Are you on call with client?
                </slot>
              </mat-checkbox>
            </div>
          </div>
          <div [hidden]="hideZipcodeBool">
            <span class="next-button-container">
              <button (click)=submit(buttonOneLabel); mat-raised-button color="primary"
              [disabled]="!agencyForm?.valid || regionMismatch || !saveableCounty" class="primary-btn proceed-button">{{buttonOneLabel}}</button>
              @if (showSecondButton && isInternal) {
                <button (click)=submit(buttonTwoLabel); mat-raised-button color="primary"
                [disabled]="!agencyForm?.valid || regionMismatch || !saveableCounty" class="primary-btn proceed-button">{{buttonTwoLabel}}</button>
              }
            </span>
          </div>
          <div [hidden]="!hideZipcodeBool || isAgencyOnlyMode">
            <button (click)="submit(buttonOneLabel)" mat-raised-button color="primary" [disabled]="!agencyForm?.valid"
            class="primary-btn">Next</button>
          </div>
          @if (isAgencyOnlyMode) {
            <div class="agency-edit-buttons">
              <button (click)="submit(buttonOneLabel)"
                mat-raised-button color="primary"
                [disabled]="!agencyForm?.valid || (enrollmentSubmitMode && regionMismatch)"
                class="primary-btn">{{ enrollmentSubmitMode ? "Submit" : "Save" }}
              </button>
              <button type="button"
                color="secondary"
                mat-raised-button
                class="btn"
                (click)="cancel()">Cancel
              </button>
            </div>
          }
        </form>
      </div>
      <div class='div-right'>
        <slot name="img_welcome"></slot>
      </div>
    </div>
  }

  @if (isAuthoring) {
    <div class="flex-change">
      <div class="div-left">
        <div>
          <h3 class="sub-header">
            <slot name="text_two">Enter state and Agency Details</slot>
          </h3>
          <div class='sub-text'>
            <slot name="subText_two">
            </slot>
          </div>
        </div>
        <div class='sub-text'>
          <slot name="subText_three">
            Add client's zip code and county information to view products.
          </slot>
        </div>
        <slot name="subText_four">
          Are you on call with client?
        </slot>
      </div>
      <div class='div-right'>
        <slot name="img_welcome"></slot>
      </div>
    </div>
  }
